import { useFormatter } from "@/hooks/useFormatter";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { VersionActions, VersionDetailTabs } from "@/resources-def/versionSettings-comp";
import { useTranslation } from "react-i18next";

const RESOURCE = 'versionSettings';

export const VersionPage = () => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();
  const { formatDateTime } = useFormatter();

  const navigateToDetail = (record, e) => {
    e.preventDefault();
    navigate({ resource: RESOURCE, key: record.id, action: 'show' });
  };

  const columns = [
    { title: t("settings.versions.fields.sprint"), dataIndex: "sprint" },
    { title: t("settings.versions.fields.imageVersion"), dataIndex: "aiops_image_version" },
    { title: t("settings.versions.fields.platformVersion"), dataIndex: "viaops_image_version" },
    { title: t("settings.versions.fields.includeModules"), dataIndex: "included_modules" },
    { title: t("settings.versions.fields.optionalModules"), dataIndex: "optional_modules" },
    { title: t("instances.fields.created_on"), dataIndex: "created_on", render: (value) => formatDateTime(value) }
  ];

  return (
    <ResourceListLayout
      title={t("settings.versions.menu.label", "AIOps Versions")}
      resource={RESOURCE}
      keyField={["sprint", "aiops_image_version"]} // Using composite key
      actions={VersionActions}
      columns={columns}
      details={VersionDetailTabs()}
    >
    </ResourceListLayout>
  );
};